<template>
  <div class="reports">
    <div class="reports-listing">
      <div class="filter-wrapper">
        <md-datepicker v-model="period.from" md-immediately>
          <label>Od</label>
        </md-datepicker>
        <md-datepicker v-model="period.to" md-immediately>
          <label>Do</label>
        </md-datepicker>
        <md-button class="md-raised md-dense md-primary" v-on:click="showReport()">
          Traži
        </md-button>
      </div>
      <div v-if="$store.state.reportsInGuests && Object.keys($store.state.reportsInGuests.play).length > 0" ref="reports" class="reports">
        <h2 class="md-title">
          Gostovanja u periodu
          {{ new Date(period.from).toLocaleDateString("hr-HR") }}
          -
          {{ new Date(period.to).toLocaleDateString("hr-HR") }}
        </h2>
              <md-table class="print-table general-table">
        <md-table-row>
          <md-table-head>Datum i vrijeme</md-table-head>
          <md-table-head>Zauzeto</md-table-head>
          <md-table-head></md-table-head>
          <md-table-head>Raspoloživo</md-table-head>
        </md-table-row>
      </md-table>
      <md-table v-for="play in $store.state.reportsInGuests.play" class="print-table general-table">
        <md-table-row v-for="performance in play.performances">
          <md-table-cell>{{ play.title }} {{ new Date(performance.start_time).toLocaleDateString('hr-HR') }}</md-table-cell>
          <md-table-cell>{{ performance.used }}</md-table-cell>
          <md-table-cell>/</md-table-cell>
          <md-table-cell>{{ performance.available }}</md-table-cell>
        </md-table-row>
        <md-table-row class="last-row">
          <md-table-cell><strong>{{ play.title}} - broj izvedbi: {{ Object.keys(play.performances).length }}</strong></md-table-cell>
          <md-table-cell>{{ play.used }}</md-table-cell>
          <md-table-cell>/</md-table-cell>
          <md-table-cell>{{ play.available }}</md-table-cell>
        </md-table-row>
      </md-table>
      <md-table class="print-table general-table">
        <md-table-row class="last-row">
          <md-table-cell><strong>Sveukupno</strong></md-table-cell>
          <md-table-cell>{{ $store.state.reportsInGuests.general.used }}</md-table-cell>
          <md-table-cell>/</md-table-cell>
          <md-table-cell>{{ $store.state.reportsInGuests.general.available }}</md-table-cell>
        </md-table-row>
      </md-table>
      <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.reports)">
        Ispiši
      </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from "../../../mixins/reports-mixin";
import FormatCurrency from "../../../mixins/format-currency";

export default {
  name: "ReportsInGuests",
  mixins: [FormatCurrency, ReportsMixin("")],
  data() {
    return {};
  },
  methods: {
    async showReport() {
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {
        from: this.period.from.toLocaleDateString("hr-HR"),
        to: this.period.to.toLocaleDateString("hr-HR"),
      };
      await this.$store.dispatch("getReportsInGuests", filter);
      this.$store.state.pageLoaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.reports {
  padding-bottom: 80px;
}
.reports h2 {
  text-align: center;
  margin: 50px 0;
  span {
    display: block;
  }

  .lighter {
    margin-top: 15px;
    font-size: 16px;
  }
}

.filter-wrapper {
  display: flex;
  position: relative;
  max-width: 900px;

  .md-field {
    margin-right: 20px;
  }
}

.error {
  font-size: 22px;
  margin: 50px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}

.with-button {
  align-self: flex-end;
  margin-bottom: 20px;
}

.md-table {
  &:not(:first-of-type) {
    & + .md-table {
      margin-top: 50px;
    }
  }
}

table {
  text-align: left;
  td,
  th {
    &:first-of-type {
      width: 200px;
      max-width: 200px;
      min-width: 200px;
    }
    &:not(:first-of-type) {
      width: 100px;
      min-width: 100px;
      max-width: 100px;
    }
  }
}

.download-report {
  margin-right: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsInGuests.vue